export default __webpack_public_path__ + "static/media/penink02.bdb6ee5f.png";